// Admin dashboards are dense tables that want the whole viewport, so the site
// header is dropped entirely on these routes.
const NAV_HIDDEN_PATHS = [
  '/dashboard-process-logs',
  '/dashboard-daily-usage',
  '/dashboard-subscriptions',
  '/dashboard-promo-codes',
  '/dashboard-revenue',
  '/dashboard-logs-feedback',
];

export const isNavHidden = (pathname: string) =>
  NAV_HIDDEN_PATHS.includes(pathname.replace(/\/+$/, '') || '/');
